import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Spinner from "../../Layouts/Spinner";
import {
  addCatagoriesValidation,
  addServiceValidation,
} from "../../Constant/constant";
import { addNewCategories } from "../../../redux/categories/action";
import ReactSelect from "react-select";
import { userCategoriesList } from "../../../redux/user/action";
import { addNewService } from "../../../redux/service/action";

const AddService = () => {
  const [loading, setLoading] = useState(false);
  const [selectStatus, setSelectStatus] = useState("");
  const [selectPosition, setSelectPosition] = useState("");
  const [selectedOptions, setSelectedOptions] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState({
    type: 2,
  });

  const categoryList = useSelector(
    (state) => state?.reusableSlice?.categoryList
  );
  console.log(categoryList, "categoryListcategoryList");
  const proOptions = categoryList?.categories?.map((item) => ({
    value: item?.id,
    label: item?.title,
  }));

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: "",
      status: 0,
      position: "",
      ar_title: "",
      category_id: "",
    },
    validationSchema: addServiceValidation,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (values) => {
    const data = {
      ...values,
    };
    dispatch(addNewService(data, setLoading, navigate));
  };

  const handleChangeStatus = (e) => {
    const gender = e.target.value;
    setSelectStatus(gender);
    formik.setFieldValue("status", Number(gender));
  };
  const handleChangePosition = (e) => {
    const pos = e.target.value;
    setSelectPosition(pos);
    formik.setFieldValue("position", Number(pos));
  };

  const handleChange = (selected) => {
    setSelectedOptions(selected);
    const categoryIds = selected.map((option) => option.value).join(",");
    formik.setFieldValue("category_id", categoryIds);
  };

  useEffect(() => {
    dispatch(userCategoriesList(params));
  }, [dispatch, params]);

  console.log(formik.values, "sadfsfdsfsfdsfsd");
  return (
    <div className="px-3">

    <div className=" category-wrapper">
      <h3 className="pb-3">Add Service</h3>
      <form onSubmit={formik.handleSubmit}>
        <div className="row ">
          <div className="col-md-4 form-group">
            <label>Category</label>
            <ReactSelect
              isMulti
              value={selectedOptions}
              onChange={handleChange}
              options={proOptions}
            />
            {formik.touched.category_id && formik.errors.category_id ? (
              <div className="error">{formik.errors.category_id}</div>
            ) : null}
          </div>
          <div className="col-md-4 form-group">
            <label>Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter category title"
              name="title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.title}
            />
            {formik.touched.title && formik.errors.title ? (
              <div className="error">{formik.errors.title}</div>
            ) : null}
          </div>

          <div className="col-md-4 form-group">
            <label>Ar Title</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter ar title"
              name="ar_title"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.ar_title}
            />
            {formik.touched.ar_title && formik.errors.ar_title ? (
              <div className="error">{formik.errors.ar_title}</div>
            ) : null}
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="status">Position</label>
            <select
              id="position"
              title="position"
              className="form-control"
              onChange={handleChangePosition}
              onBlur={formik.handleBlur}
              value={formik.values.position}
            >
              <option value="">Select Position</option>
              {Array.from({ length: 50 }, (_, i) => i + 1).map(
                        (num) => (
                          <option key={num} value={num}>
                            {num}
                          </option>
                        )
                      )}
            </select>
            {formik.touched.position && formik.errors.position ? (
              <div className="error">{formik.errors.position}</div>
            ) : null}
          </div>

          <div className="form-group col-md-4">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              title="status"
              className="form-control"
              onChange={handleChangeStatus}
              onBlur={formik.handleBlur}
              value={formik.values.status}
            >
              <option value="">Select Status</option>
              <option value="1">Active</option>
              <option value="2">Inactive</option>
            </select>
            {formik.touched.status && formik.errors.status ? (
              <div className="error">{formik.errors.status}</div>
            ) : null}
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-center mt-3  "
          style={{ columnGap: "20px" }}
        >
          <button
            className="submit-btn  "
            onClick={() => {
              navigate("/services");
            }}
            style={{ width: "max-content" }}
          >
            Back
          </button>
          <button
            className="submit-btn   "
            style={{ width: "max-content" }}
            type="submit"
          >
            {!loading ? "Submit" : <Spinner />}
          </button>
        </div>
      </form>
    </div>
    </div>
  );
};

export default AddService;
